import axios from 'axios'

async function start_test(dispatch,data,token,setOpen,setMessage,setSubmitting,setHasStarted,setQuestion,setIsPaused,setDiv,setTime,setCount,addData){

    setSubmitting(true)

    const URL = `${process.env.REACT_APP_SERVER_AUTH_URL}start-test/`

      const testStart = await axios.post(URL,data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${token}`
              }
       }).catch(err=>{console.log(err)})

      if (testStart?.status == 200 && testStart?.data.success == true) {

      setSubmitting(false)
      setQuestion(testStart?.data.question)
      setCount(testStart?.data?.count || 0)
      setHasStarted(true)
      setIsPaused(false)
      setTime(data?.test?.time*60)
      setDiv((data?.test.time*60)/data?.test.questions) 
      addData({
        title:"Assessment passed",
        specialty:data.test?.specialty,
        field:data.test?.field,
        isCreated:false,
        level:data.test?.level,
        language:data.test?.language,
        questions:data.test?.questions,
        id:data.test?.id,
        from:data.test?.name,
        start_moment:data.test?.start_moment,
        start_date:data.test?.start_date,
        time:data.test?.time,
        description:data.test?.description
      })

      }else{
        setSubmitting(false)
        setHasStarted(false)
        setMessage(testStart?.data?.message)
        setOpen(true)
      }
}

export default start_test